/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../../fragments'

import {
  Input,
  Spinner,
  Select,
  SelectWithData,
  SpanWithData,
  InfoDisplay,
} from '../../'

import { decodeBase64 } from '../../../utils'


export class EmployeeEmployment extends React.PureComponent {
  static propTypes = {
    client: PropTypes.string.isRequired,
    title: PropTypes.string,
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    readOnly: false
  }

  state = {
    editEmploymentInfo: false,
    employmentType: "Loading",
    employeeNumber: "Loading",
    // salary: "Loading",
    payrollcycle: "Loading",
    status: "Loading",
    statusReason: "Loading",
    saveInProgress: false
  }

  goEditEmploymentInfo = () => {
    let client = this.props.data.client

    this.setState({
      editEmploymentInfo: true,
      employmentType: client.employmentType,
      employeeNumber: client.employeeNumber,
      // salary: client.salary,
      employer: client.division.employer.id,
      division: client.division.id,
      payrollcycle: client.payrollcycle ? client.payrollcycle.id : null,
      status: client.status,
      employerStatus: client.division.employer.identity.membershipStatus,
      statusReason: client.statusReason
    })
  }

  goReadOnly = () => {
    this.setState({
      editEmploymentInfo: false,
      saveInProgress: false
    })
  }

  noChangesToSave = () => {
    let client = this.props.data.client

    return client.employmentType === this.state.employmentType &&
      client.employeeNumber === this.state.employeeNumber &&
      // client.salary === this.state.salary &&
      client.status === this.state.status &&
      client.statusReason === this.state.statusReason &&
      (client.payrollcycle
        ? this.state.payrollcycle === null || client.payrollcycle.id === this.state.payrollcycle
        : this.state.payrollcycle === null
      )
      //  &&
      // client.division.id === this.state.division
  }

  handleEmploymentInfoUpdate = () => {
    this.setState({ saveInProgress: true })
    let client = this.props.data.client
    let input = {
      id: client.id
    }

    if (client.employmentType !== this.state.employmentType)
      input.employmentType = this.state.employmentType

    if (client.employeeNumber !== this.state.employeeNumber)
      input.employeeNumber = this.state.employeeNumber

    // if (client.salary !== this.state.salary)
    //   input.salary = this.state.salary

    if (client.status !== this.state.status)
      input.status = this.state.status.toLowerCase()

    if (client.statusReason !== this.state.statusReason)
      input.statusReason = this.state.statusReason

    if (client.payrollcycle) {
      if (client.payrollcycle.id !== this.state.payrollcycle) {
        input.payrollcycle = this.state.payrollcycle || "null"
      }
    } else if (this.state.payrollcycle) {
      input.payrollcycle = this.state.payrollcycle
    }

    // if (this.divisionChanged(client))
    //   input.division = this.state.division

    this.props.updateClientEmploymentDetails({ variables: { input } })
      .then(this.goReadOnly)
      .catch(() => this.setState({ saveInProgress: false }))
  }

  divisionChanged = (client) => client.division.id !== this.state.division

  render() {
    if (this.props.data.loading) {
      return <Spinner className="slds-is-relative" />
    }

    if (this.props.data.error) {
      return (<h1>Oh dear! We have an issue</h1>)
    }

    const client = this.props.data.client

    let DivisionEmployerPayrollCycles = []
    client.division.employer.payrollcycles.edges.map(({ node: payrollCycle }, i) => {
      let label = payrollCycle.name + " (" + payrollCycle.cycle.toLowerCase() + ")"
      return DivisionEmployerPayrollCycles.push({ value: payrollCycle.id, label})
    })

    let clientEmploymentRows = (
      <tbody>
        {/*<tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Division
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? <DivisionSelect
                  employer={this.state.employer}
                  value={this.state.division}
                  onChange={e => this.setState({ division: e.target.value, payrollcycle: null })}
                  noDefaultOption={client.division}
                  className='slds-size_1-of-2 slds-m-left_x-small'
                />
              : client.division.name
            }
          </td>
        </tr>*/}
        <tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Employment type
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? <SelectWithData
                  id="employmentType"
                  forField="ClientEmploymentType"
                  value={this.state.employmentType}
                  onChange={(e) => this.setState({ employmentType: e.target.value })}
                  noDefaultOption={client.employmentType}
                />
              : <SpanWithData forField="ClientEmploymentType" searchKey={client.employmentType} />
            }
          </td>
        </tr>
        <tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Employee no.
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? <Input
                  id="employeeNumber"
                  placeholder='Employee number'
                  value={this.state.employeeNumber || ""}
                  onChange={(e) => this.setState({ employeeNumber: e.target.value })}
                 />
              : client.employeeNumber
            }
          </td>
        </tr>
        {/* Salary can be calculated from the payslips that we'll be getting from TAD
        <tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Salary
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? <Input
                  id="salary"
                  placeholder='Salary'
                  value={this.state.salary || ""}
                  onChange={(e) => {
                    let salary = e.target.value
                    this.setState({ salary: salary === '' ? null : salary })
                  }}
                />
              : client.salary
            }
          </td>
        </tr>*/}
        <tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Payroll cycle
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? !this.divisionChanged(client) &&
                  <Select
                    id='payrollcycle'
                    placeholder='Choose payroll cycle'
                    default={true}  // default is set to show a empty value in drop-down option list
                    value={this.state.payrollcycle}
                    options={DivisionEmployerPayrollCycles}
                    onChange={e => (
                      this.setState({
                        payrollcycle: e.target.value === ''
                          ? null
                          : e.target.value
                      })
                    )}
                  />
              : client.payrollcycle &&
                  <span>
                    {client.payrollcycle
                      ? `${client.payrollcycle.name} (${client.payrollcycle.cycle.toLowerCase()})`
                      : ''
                    }
                  </span>
            }
          </td>
        </tr>
        <tr>
          <th className='slds-size_1-of-4 slds-cell-wrap slds-theme_shade slds-text-heading_label'>
            Status
          </th>
          <td>
            {this.state.editEmploymentInfo
              ? <div className="slds-grid">
                  <SelectWithData
                    id="status"
                    forField="ClientStatus"
                    value={this.state.status}
                    onChange={(e) => this.setState({ status: e.target.value })}
                    noDefaultOption={true}
                    className="slds-size_1-of-2 slds-m-right_x-small"
                  />
                  <div className="slds-text-title_caps slds-m-top_x-small">
                    Reason:
                  </div>
                  <Input
                    id="statusReason"
                    placeholder='Status change reason'
                    value={this.state.statusReason}
                    onChange={(e) => this.setState({ statusReason: e.target.value })}
                    className="slds-m-left_xx-small"
                  />
                </div>
              : <div className="slds-grid">
                  <SpanWithData
                    forField="ClientStatus"
                    searchKey={client.status}
                    className="slds-size_1-of-2 slds-m-right_x-small"
                  />
                  <div className="slds-text-title_caps slds-m-top_x-small slds-m-right_x-small">
                    Reason:
                  </div>
                  <div className="slds-m-top_xxx-small">
                    {client.statusReason || 'None specified'}
                  </div>
                </div>
            }
          </td>
        </tr>
      </tbody>
    )

    return (
      <InfoDisplay
        title='Employment'
        rows={clientEmploymentRows}
        edit={this.state.editEmploymentInfo}
        onCancelClick={this.goReadOnly}
        onSaveClick={this.handleEmploymentInfoUpdate}
        onEditClick={this.goEditEmploymentInfo}
        saveDisabled={this.noChangesToSave() || this.state.saveInProgress}
        saveButtonLabel={this.state.saveInProgress ? 'Saving...' : null}
        noButtons={this.props.readOnly}
        titleBold={false}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getClientEmploymentDetails = gql`query($client: ID!) {
    client(id: $client) {
      ...ClientEmployment
      payrollcycle {
        ...PayrollCycle
      }
    }
  }
  ${fragments.clientEmployment}
  ${fragments.payrollcycle}
`

const updateClientEmploymentDetails = gql`
  mutation updateClientEmploymentDetails($input: ClientMutationInput!) {
    clientMutate(input: $input) {
      client {
        ...ClientEmployment
        payrollcycle {
          ...PayrollCycle
        }
      }
    }
  }
  ${fragments.clientEmployment}
  ${fragments.payrollcycle}
`

const withData =
  graphql(getClientEmploymentDetails, {
    options: ({ client, employer }) => ({
      variables: {
        client,
        employer: decodeBase64(employer)
      }
    })
  })

const withUpdate =
  graphql(updateClientEmploymentDetails, {
    name: 'updateClientEmploymentDetails'
  })

export default compose(
  withData,
  withUpdate
)(EmployeeEmployment)



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-employment/index.js